import type { JsonData } from '../generic-types';

export interface ContinuousScrollerState {
  isLoading: boolean;
  renderPages?: Array<number>;
  searchResults?: JsonData;
}

export const ContinuousScrollerActionType = {
  SetSearchResults: 0,
  SetIsLoading: 1,
  SetRenderPages: 2,
} as const;
export type ContinuousScrollerActionType =
  (typeof ContinuousScrollerActionType)[keyof typeof ContinuousScrollerActionType];

export interface ContinuousScrollerReducerAction {
  type: ContinuousScrollerActionType;
  isLoading?: boolean;
  renderPages?: Array<number>;
  searchResults?: JsonData;
}

export default function reducer(state: ContinuousScrollerState, action: ContinuousScrollerReducerAction) {
  switch (action.type) {
    case ContinuousScrollerActionType.SetSearchResults:
      return {
        ...state,
        searchResults: action.searchResults,
      };

    case ContinuousScrollerActionType.SetIsLoading:
      if (action.isLoading !== undefined) {
        if (action.renderPages) {
          return {
            ...state,
            isLoading: action.isLoading,
            renderPages: action.renderPages,
          };
        }

        return {
          ...state,
          isLoading: action.isLoading,
        };
      }

      return state;
    case ContinuousScrollerActionType.SetRenderPages:
      if (action.renderPages) {
        return {
          ...state,
          renderPages: action.renderPages,
        };
      }

      return state;
  }
}
